import { z } from 'zod';
import { ApplicationSchema } from './application';
import { IsoTimestampSchema, UuidSchema } from './common';
import { LogWithRelationsSchema } from './log';

export const ChannelResultSchema = z.object({
  channel: z.enum(['email', 'webhook', 'slack', 'discord', 'push']),
  status: z.enum(['sent', 'failed', 'silenced']),
  error: z.string().optional(),
});

export const AlertEventSchema = z.object({
  id: UuidSchema,
  ruleId: UuidSchema,
  triggeredAt: IsoTimestampSchema,
  triggeringLogId: UuidSchema.nullable(),
  applicationId: UuidSchema,
  channelsResult: z.array(ChannelResultSchema),
});

export const AlertEventWithRelationsSchema = AlertEventSchema.extend({
  application: ApplicationSchema.pick({
    id: true,
    name: true,
    product: true,
    company: true,
    instance: true,
  }),
  triggeringLog: LogWithRelationsSchema.nullable(),
});

export const ListAlertEventsQuerySchema = z.object({
  ruleId: UuidSchema.optional(),
  applicationId: UuidSchema.optional(),
  from: IsoTimestampSchema.optional(),
  to: IsoTimestampSchema.optional(),
  limit: z
    .string()
    .optional()
    .default('100')
    .transform((v) => Number.parseInt(v, 10))
    .pipe(z.number().int().min(1).max(500)),
  cursor: z.string().optional(),
});

export const ListAlertEventsResponseSchema = z.object({
  items: z.array(AlertEventSchema),
  nextCursor: z.string().nullable(),
});

export type ChannelResult = z.infer<typeof ChannelResultSchema>;
export type AlertEvent = z.infer<typeof AlertEventSchema>;
export type AlertEventWithRelations = z.infer<typeof AlertEventWithRelationsSchema>;
export type ListAlertEventsQuery = z.infer<typeof ListAlertEventsQuerySchema>;
export type ListAlertEventsResponse = z.infer<typeof ListAlertEventsResponseSchema>;
